import * as Sentry from '@sentry/react';
import { useUserContext } from "../contexts/UserContext";
import { apiSwitchOrg } from "../helpers/api";
import { setLocalStorage } from "../helpers/jsHelper";
import { errorToast } from "../helpers/toastHelper";
import { useCheckCuratorActive } from "./useCuratorActive";
import { selectIsBulkTextureProcessing } from '../redux/slicers/bulkTextureUpload';
import { getAppState } from '../redux/store';

export const useSwitchToOrganization = () => {
  const userCtx = useUserContext()
  const { isCuratorActive } = useCheckCuratorActive();
  const isTexturesAreProcessing = selectIsBulkTextureProcessing(getAppState());

  const switchToOrganization = async (orgId, { onSuccess } = {}) => {
    if(!orgId) return;

    const curatorActive = await isCuratorActive();
    if (curatorActive) {
      errorToast("Please close or save any open project to change your current organization");
      return;
    }

    if (isTexturesAreProcessing) {
      errorToast("Please wait!!! Your texture files are in processing.");
      return;
    }

    let res = await apiSwitchOrg(orgId);
    if (res) {
      if (res?.is_editor) {
        res.info['is_editor'] = res?.is_editor;
      }
      setLocalStorage('token', res.access);
      setLocalStorage('refresh_token', res.refresh);
      // setLocalStorage('current_user', res.info);
      userCtx.setToken(res.access);
      userCtx.setRefreshToken(res.refresh);
      userCtx.setCurrentUser(res.info);
      
      if (res?.info?.id) {
        Sentry.setUser({
          id: res.info.id,
          organization: orgId,
        });
      }
  
      onSuccess?.();
    }
  }

  return { switchToOrganization }
}